import React, { useState, useEffect } from 'react';
import { bankLabel } from '../utils/bank';
import './PayTicketDetailModal.css';
import './TicketViewModal.css';

// Detail d'une fiche en LECTURE SEULE, ouvert en cliquant une ligne de
// "Tickets Vendus" (company ET superviseur, 2026-10-02) : toutes les boules
// jouees + entete (serial, SQ, statut annule/paye, gain par ligne). Meme
// habillage que PayTicketDetailModal (classes ptm-*), sans le flux de paiement.
// `fetcher(ticketId)` = fetchTicketDetail (company) ou
// fetchSupervisorTicketDetail (superviseur), meme reponse
// (tickets/views.py:_ticket_detail_payload).
const money = (n) => Number(n || 0).toFixed(2);

const TicketViewModal = ({ ticketId, fetcher, onClose }) => {
  const [ticket, setTicket] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError('');
    fetcher(ticketId)
      .then((d) => { if (!cancelled) setTicket(d); })
      .catch(() => { if (!cancelled) setError('Impossible de charger la fiche.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [ticketId, fetcher]);

  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div className="ptm-overlay" onClick={onClose}>
      <div className="ptm-modal tvm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="ptm-header">
          <span className="ptm-title">Fiche {ticket?.no != null ? `#${ticket.no}` : ''}</span>
          <button className="ptm-close-btn" onClick={onClose}>✕</button>
        </div>

        <div className="ptm-body">
          {loading && <p className="tvm-loading">Chargement...</p>}
          {error && <p className="ptm-error">{error}</p>}

          {ticket && !loading && (
            <>
              <div className="ptm-bank-box">
                <strong>Banque:</strong> {bankLabel(ticket.bank_seq, ticket.bank_name)}{ticket.bank_username ? ` (${ticket.bank_username})` : ''}
              </div>

              <div className="ptm-info-grid">
                <span><strong>Date:</strong> {ticket.date}</span>
                <span><strong>Heure:</strong> {ticket.time}</span>
                <span><strong>Sequence:</strong> {ticket.sq ?? '—'}</span>
                <span><strong>Serial:</strong> {ticket.serial || '—'}</span>
                <span><strong>Type:</strong> {ticket.online ? 'Online' : 'Local'}</span>
                <span><strong>Paris:</strong> {ticket.lines.length}</span>
              </div>

              {ticket.is_deleted && (
                <p className="tvm-status tvm-status-deleted">
                  ANNULÉE{ticket.deleted_at ? ` le ${ticket.deleted_at}` : ''}
                  {ticket.deleted_by ? ` par ${ticket.deleted_by}` : ''}
                </p>
              )}
              {!ticket.is_deleted && ticket.is_paid && (
                <p className="tvm-status tvm-status-paid">PAYÉE</p>
              )}

              <div className="ptm-divider" />

              <div className="ptm-tags-row">
                <span className="ptm-tag">
                  <span className="ptm-tag-label">Loterie:</span> {ticket.tirage_code}|{ticket.tirage_name}
                </span>
              </div>

              <table className="ptm-table">
                <thead>
                  <tr><th>Produit</th><th>Boule</th><th>Mise</th><th>Gagne</th></tr>
                </thead>
                <tbody>
                  {ticket.lines.map((line, i) => (
                    <tr
                      key={i}
                      className={[line.gain > 0 ? 'ptm-line-won' : '', line.bold ? '' : 'tvm-line-light'].join(' ')}
                      title={line.moveType}
                    >
                      <td>{line.abbr || line.moveType}</td>
                      <td className="tvm-number">{line.number}</td>
                      <td className="ptm-amount">{money(line.amount)}</td>
                      <td className="ptm-amount">{line.gain > 0 ? money(line.gain) : '—'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="ptm-total-bar">
                Total mise: {money(ticket.total_amount)} — Total gagne: {money(ticket.total_gain)}
              </div>
            </>
          )}
        </div>

        <div className="ptm-footer">
          <button className="ptm-close-action" onClick={onClose}>Fermer</button>
        </div>
      </div>
    </div>
  );
};

export default TicketViewModal;
